// extracted by mini-css-extract-plugin
export var actionButton = "_pi-0";
export var actionMenuContainer = "_pi-i";
export var bubble = "_pi-2";
export var bubbleActionMenu = "_pi-j";
export var bubbleContext = "_pi-6";
export var bubbleItems = "_pi-7";
export var customer = "_pi-3";
export var divider = "_pi-8";
export var fileList = "_pi-9";
export var hiddenComment = "_pi-o";
export var infoAbove = "_pi-a";
export var internal = "_pi-4";
export var lightActionButton = "_pi-1";
export var link = "_pi-b";
export var merchant = "_pi-5";
export var message = "_pi-c";
export var profilePicture = "_pi-e";
export var quillToolbarContainer = "_pi-f";
export var senderDate = "_pi-g";
export var senderDateCustomer = "_pi-h";
export var senderName = "_pi-d";
export var time = "_pi-k";
export var uploadedImage = "_pi-l";
export var username = "_pi-m";
export var xsmall = "_pi-n";